import { APP_ENV } from 'config';

const prefix = (key: string) => `__OA__${APP_ENV}__${key}`;

export const FF_OVERRIDES = prefix('ff_overrides');
